
import { AppService } from "app/services/app.service";

import { AppFilter } from "app/models/app-filter.model";
import { Observable } from "rxjs";

export abstract class AbInadimplente extends AppService {
  abstract getAllInadimplentes(filter: AppFilter): Observable<any>;
  abstract saveInadimplentes(inadimplente: any): Observable<any>;
  abstract retirarPendencia(id: any): Observable<any>;
  abstract deletar(id: number);
  abstract getById(id: number): Observable<any>;
  abstract getResponsavelByUnidadeId(unidadeId: number);

}